/*
  ButtonWithFileInput.jsx
*/

// Npm.
import React, { useRef } from 'react';

// Components.
import Button from './Button';

/**
 * Button that comes with a file input.
 */
export default function ButtonWithFileInput({
  
  // Input props.
  type,
  accept,
  onChange,

  // Button props.
  onClick,
  ...rest

}) {

  const inputFileRef = useRef();

  function handleClick(event) {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
    if (onClick) {
      onClick(event);
    }
  }

  return (
    <>

      <input
        ref={inputFileRef}
        onChange={onChange}
        type={type}
        accept={accept}
        hidden
        style={{ display: 'none' }}
      />

      <Button onClick={handleClick} {...rest} />

    </>
  );
}
